import { API } from "@aws-amplify/api";

const query =`query($input:PackMaterialsInput!) {
  getPackMaterials(input: $input) {
  bolNo
  section {
  dataItems {
  hasSubContent
  label
  subText
  value
  }
  rowItems {
  hasSubContent
  label
  subText
  value
  }
  subTitle
  title
  }
  subTitle
  title
  }
  }`;

export async function getPackMaterials(cid: any): Promise<any> {
  try {
    const response: any = await API.graphql({
      query: query, variables: {
        input: {
          cid: cid
        }
      },
    });
    return response.data.getPackMaterials
  } catch (error) {
    console.log("getPackMaterials", error);
  }
}
